export default __webpack_public_path__ + "static/pic02-5b903db71c06f6c270d08a84ec4b6113.jpg";